import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const contractLocaleModule: LocaleModule = {
  name: "contract",
  messages: { en: en, it: it },
};
